import type { StylesConfig } from "react-select";
import { FormattedMessage } from "@/i18n/i18n-client";
import { SortOrder } from "@/generated/graphql";
import { FlexRow, P } from "@/shared/globals";
import { sortOptions } from "../../../default/components/Filter/consts";
import { ZIndex } from "@/shared/globals/types";
import { usePathname, useSearchParams } from "@/i18n/i18n-navigation";
import { useNavigateLoading } from "@/hooks/useNavigate";
import LoadingBar from "@/components/LoadingBar/LoadingBar";
import { LazySelect } from "@/shared/globals/LazyElements/react-select";

export const Sorting = () => {
  const [isFetching, navigate] = useNavigateLoading();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleChange = (selectedOption: {
    value: { sortBy: string; sortOrder: SortOrder };
  }) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", "1");

    if (selectedOption.value.sortBy) {
      params.set("sortBy", selectedOption.value.sortBy);
    }

    if (selectedOption.value.sortOrder) {
      params.set("sortOrder", selectedOption.value.sortOrder);
    }

    navigate(`${pathname}?${params.toString()}`);
  };

  const sort = {
    sortBy: searchParams.get("sortBy"),
    sortOrder: searchParams.get("sortOrder"),
  };
  return (
    <FlexRow margin="20px 0 0">
      <LoadingBar isLoading={isFetching} />
      <P fontSize="16px" fontWeight={600}>
        <FormattedMessage defaultMessage="Sort by:" id="40bnK/" />
      </P>
      <LazySelect
        instanceId="select-sorting"
        options={sortOptions}
        onChange={handleChange}
        styles={customStyles}
        defaultValue={sortOptions.find(
          (option) => option.key === `${sort.sortBy}-${sort.sortOrder}`
        )}
        isSearchable={false}
        placeholder={
          <FormattedMessage defaultMessage="Default Sorting" id="mNK9is" />
        }
        components={{ IndicatorSeparator: () => null }}
      />
    </FlexRow>
  );
};

// Functions

const secondaryColor = "#525252"; // theme.colors.secondary
const customStyles: StylesConfig = {
  control: (provided) => ({
    ...provided,
    border: "none",
    fontWeight: "500",
    cursor: "pointer",
    boxShadow: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: secondaryColor,
    fontWeight: 400,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: secondaryColor,
    fontWeight: 400,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "4px",
    boxShadow: "0px 4px 10px 0px rgba(182, 182, 182, 0.25)",
    backgroundColor: "white",
    zIndex: ZIndex.OVERLAY,
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "1.43",
    color: secondaryColor,
    backgroundColor: "white",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#F5F5F5",
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: secondaryColor,
  }),
};
